import React, { useRef, useState } from "react";
import CusSelect from "../../mui/cus_select/CusSelect";
import "./find-game.scss";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setSaveSiteBeforeGame } from "../../../store/commonSlice";
import useNavigateWithSearch from "../../../hooks/useNavigateWitchSearch";
import useChooseMode from "../../../hooks/useChooseMode";
import IconSearch from "../../mui/JSXIcons/IconSearch";
import { API_CASINO } from "../../../api/casino";
import { checkBonusGame } from "../../../utils/utils";
import { useAppSelector } from "../../../store/index.ts";

export default function FindGame({ inputId }) {
  const navigate = useNavigateWithSearch();
  const dispatch = useDispatch();
  const { onChoseMode } = useChooseMode();
  const { t } = useTranslation();
  const currency = useAppSelector((state) => state.user.currency);

  const [inputValue, setInputValue] = useState("");
  const [gamesOptions, setGamesOptions] = useState([]);

  const tmSearchRef = useRef("");
  const findRef = useRef(null);

  // const gamesOptions = games.map((el) => ({
  //   label: el.nameAndProviders,
  //   value: el.id,
  //   isBonus: el.isBonus,
  //   image: el.image,
  //   name: el.nameAndProviders
  // }));

  const onSearch = (value) => {
    API_CASINO.list
      .search({ sample: value, currency })
      .then((e) => {
        const list = e.data.list;

        const alreadyLabel = new Set();
        const gameOptions = list.map((el) => {
          let label = `${el.name} ${el.provider}`;
          if (alreadyLabel.has(label)) label += `(${el.gameId})`;

          alreadyLabel.add(label);

          return {
            label: label,
            value: el.gameId
          };
        });

        setGamesOptions(gameOptions);
      })
      .catch(console.error);
  };

  const onMyInputChange = (e) => {
    const value = e.target.value;

    if (value.length >= 3) {
      clearTimeout(tmSearchRef.current);
      tmSearchRef.current = setTimeout(() => onSearch(value), 500);
    } else setGamesOptions([]);

    setInputValue(value);
  };

  const onSelectGame = (gameId) => {
    API_CASINO.list
      .games({ gameId, currency })
      .then((e) => {
        const list = e.data.list;
        const game = list.find((el) => el.game_id == gameId);
        const isBonus = checkBonusGame(game);
        const urlGame = isBonus ? "bonus_game" : "game";
        const pathName = window.location.pathname;

        const runGame = () => {
          dispatch(setSaveSiteBeforeGame({ url: pathName, topScroll: window.scrollY }));
          navigate(`/${urlGame}/${gameId}`);
        };

        console.log("item", game);

        onChoseMode({ cbReal: runGame, cbDemo: runGame, game: game });
      })
      .catch(console.error);
  };

  return (
    <label className="find-game" htmlFor={inputId}>
      <CusSelect
        inputRef={findRef}
        icon={<IconSearch />}
        input
        inputId={inputId}
        options={gamesOptions}
        placeholder={t("Find a game")}
        myInputValue={inputValue}
        onChange={onSelectGame}
        onMyInputChange={onMyInputChange}
      />
    </label>
  );
}
